function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "accessories_svg__cls-2",
  d: "M111.35 80.09c-.65 0-1.31-.12-1.93-.36L74.74 66.58V38.85l34.68-13.15c1.67-.63 3.55-.41 5.03.61a5.456 5.456 0 012.35 4.49v43.85c0 1.79-.88 3.47-2.35 4.49-.92.64-2 .96-3.09.96zM79.74 63.13l31.45 11.93c.15.06.29.04.41-.05.13-.09.19-.21.19-.37V30.79c0-.16-.07-.28-.19-.37a.407.407 0 00-.41-.05L79.74 42.3v20.83zM21.19 80.09c-1.09 0-2.17-.33-3.09-.96a5.452 5.452 0 01-2.35-4.48V30.79c0-1.79.88-3.47 2.35-4.48a5.428 5.428 0 015.03-.61l34.68 13.15v27.73L23.13 79.73c-.63.24-1.28.35-1.93.35zm0-49.75c-.09 0-.17.03-.25.08-.13.09-.19.21-.19.37v43.85a.442.442 0 00.6.42L52.8 63.13V42.3L21.35 30.37a.508.508 0 00-.17-.03z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "accessories_svg__cls-2",
  d: "M50.04 106.65h-.07a2.908 2.908 0 01-2.73-2.1l-3.49-12.11-12.09 4.13c-1.2.41-2.52 0-3.27-1.02-.76-1.02-.77-2.4-.03-3.43l18.97-26.46 4.06 2.91-15.16 21.15 7.99-2.73c.75-.25 1.58-.19 2.28.17.7.36 1.23 1.01 1.45 1.76l2.26 7.84 10.36-30.33-.25-.13.95-1.91h.03l1.31-2.53 4.09 2.11-13.9 40.69c-.4 1.18-1.5 1.97-2.75 1.97zM32.42 95.04zM53.54 62.71l-.01-.01 3.54-3.54-3.53 3.55z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "accessories_svg__cls-2",
  d: "M82.5 106.65c-1.25 0-2.34-.78-2.75-1.97l-13.9-40.69 4.09-2.11 1.31 2.54h.03l.07.19.88 1.71-.25.13 10.35 30.32 2.25-7.82a2.91 2.91 0 013.74-1.94l7.99 2.73-15.15-21.16 4.06-2.91 18.96 26.46c.74 1.03.73 2.41-.03 3.43a2.89 2.89 0 01-3.28 1.01l-12.09-4.13-3.49 12.1a2.887 2.887 0 01-2.72 2.1h-.07zm17.61-11.61zm2.37-3.2zm-13.09-1.51z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "accessories_svg__cls-2",
  transform: "rotate(-26.34 77.217 60.958)",
  d: "M77.13 58.45h.11v5h-.11z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "accessories_svg__cls-2",
  d: "M79.64 66.6H52.81V38.85h26.83V66.6zm-21.83-5h16.83V43.85H57.81V61.6z"
});

function SvgAccessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "accessories_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgAccessories;